//The functions in here are somewhat redundant with stuff in the rulesEvaluator.js.
//  This is prep for eventually being able to combine them into this helper with small
//  modifications.
import { hasValue } from 'swipeclock-frontend';

function userHasRole(itemRoles, userRoles) {
  return itemRoles?.some((role) => {
    return userRoles?.findIndex((x) => x.roleType === role) > -1;
  });
}

function partnerHasSystem(itemSystems, partnerSystems) {
  return itemSystems?.some((system) => {
    return partnerSystems?.findIndex((x) => x.name === system) > -1;
  });
}

export function hasUserRole(itemRoles, userRoles) {
  //no roles assigned to the drawer item, all have permission.
  if (!hasValue(itemRoles)) {
    return true;
  }

  //Lastly, check the roles we have against the user roles
  return userHasRole(itemRoles, userRoles);
}

//Check to see if the drawer item has appropriate permission(s).
export function hasPermission(
  permissions,
  userPermissions,
  PartnerPermissionLevel
) {
  //No permissions on the drawer item?  Assume everyone can see it.
  if (!hasValue(permissions)) {
    return true;
  }

  //Check to see if there are any matching permissions from the user
  // within the drawer item.  So if any of the permissions match, sweet.
  // Currently this isn't very sophisticated in it's permission level check.
  // for now it suffices to just not be 'none', but in the future I could see
  // the need for maybe a 'getLowestPermission' level for the menu items passed
  // permissions (maybe it becomes an object at that point?), then match against
  // that.  For now though, that would be a yucky overengineering in the single
  // use-case we are currently doing.
  return permissions?.some(
    (permission) =>
      userPermissions?.findIndex(
        (x) =>
          x.permissionId === permission &&
          x.permissionLevel !== PartnerPermissionLevel.none
      ) > -1
  );
}

export function hasSystem(itemSystems, partnerSystems) {
  //no roles assigned to the drawer item, all have permission.
  if (!hasValue(itemSystems)) {
    return true;
  }

  //Lastly, check the roles we have against the user roles
  return partnerHasSystem(itemSystems, partnerSystems);
}
